'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dotPropImmutable = require('dot-prop-immutable');

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _workflow = require('../../constants/actions/workflow');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
    anonymous: false,
    entity: null,
    valid: true,
    control: null,
    step: null,
    stages: null,
    dynamicDate: null,
    returns: [],
    stepAnalytics: null,
    workflowConfiguration: null
};

function workflowReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var returnIndex = 0,
        elementIndex = 0;
    switch (action.type) {
        case _workflow.REDUCE_ANONYMOUS:
            return _dotPropImmutable2.default.set(state, 'anonymous', action.payload);
        case _workflow.REDUCE_ENTITY:
            return _dotPropImmutable2.default.set(state, 'entity', action.payload);
        case _workflow.REDUCE_DYNAMIC_DATE:
            return _dotPropImmutable2.default.set(state, 'dynamicDate', action.payload);
        case _workflow.REDUCE_VALID:
            return _dotPropImmutable2.default.set(state, 'valid', action.payload);
        case _workflow.REDUCE_CONTROL:
            return _dotPropImmutable2.default.set(state, 'control', action.payload);
        case _workflow.REDUCE_RETURNS:
            return _dotPropImmutable2.default.set(state, 'returns', action.payload);
        case _workflow.REDUCE_STEP:
            return _dotPropImmutable2.default.set(state, 'step', action.payload);
        case _workflow.REDUCE_STAGES:
            return _dotPropImmutable2.default.set(state, 'stages', action.payload);
        case _workflow.REDUCE_RETURN:
            if (state.returns.some(function (x) {
                return x.code === action.payload.componentCode;
            })) {
                returnIndex = state.returns.findIndex(function (x) {
                    return x.code === action.payload.componentCode;
                });
            } else {
                returnIndex = state.returns.length;
            }
            return _dotPropImmutable2.default.set(state, 'returns.' + returnIndex, {
                code: action.payload.componentCode,
                elements: action.payload.value
            });
        case _workflow.REDUCE_RETURN_ELEMENT:
            if (state.returns.some(function (x) {
                return x.code === action.payload.componentCode;
            })) {
                returnIndex = state.returns.findIndex(function (x) {
                    return x.code === action.payload.componentCode;
                });
                // Only for nested objects
                if (action.payload.elements) {
                    if (state.returns[returnIndex].elements && state.returns[returnIndex].elements.some(function (x) {
                        return x.value === action.payload.value;
                    })) {
                        // NOSONAR
                        elementIndex = state.returns[returnIndex].elements.findIndex(function (x) {
                            return x.value === action.payload.value;
                        });
                    } else {
                        elementIndex = state.returns[returnIndex].elements && state.returns[returnIndex].elements.length || 0; // NOSONAR
                    }
                    if (action.payload.action === "remove") {
                        return _dotPropImmutable2.default.set(state, 'returns.' + returnIndex + '.elements', []);
                    } else {
                        return _dotPropImmutable2.default.set(state, 'returns.' + returnIndex + '.elements.' + elementIndex, {
                            code: action.payload.code,
                            value: action.payload.value,
                            elements: action.payload.elements
                        });
                    }
                }

                if (state.returns[returnIndex].elements && state.returns[returnIndex].elements.some(function (x) {
                    return x.code === action.payload.code;
                })) {
                    // NOSONAR
                    elementIndex = state.returns[returnIndex].elements.findIndex(function (x) {
                        return x.code === action.payload.code;
                    });
                } else {
                    elementIndex = state.returns.find(function (x) {
                        return x.code === action.payload.componentCode;
                    }).elements && state.returns.find(function (x) {
                        return x.code === action.payload.componentCode;
                    }).elements.length || 0; // NOSONAR
                }

                return _dotPropImmutable2.default.set(state, 'returns.' + returnIndex + '.elements.' + elementIndex, {
                    code: action.payload.code,
                    value: action.payload.value
                });
            } else {
                returnIndex = state.returns.length;
                return _dotPropImmutable2.default.set(state, 'returns.' + returnIndex, {
                    code: action.payload.componentCode,
                    elements: [{ code: action.payload.code, value: action.payload.value }]
                });
            }
        case _workflow.REDUCE_RETURN_DEEP:
            if (state.returns.some(function (x) {
                return x.code === action.payload.componentCode;
            })) {
                returnIndex = state.returns.findIndex(function (x) {
                    return x.code === action.payload.componentCode;
                });
            } else {
                returnIndex = state.returns.length;
            }
            return _dotPropImmutable2.default.set(state, 'returns.' + returnIndex + '.' + action.payload.code, action.payload.value);
        case _workflow.REDUCE_TABLE_RETURN:
            {
                var _action$payload = action.payload,
                    componentCode = _action$payload.componentCode,
                    code = _action$payload.code,
                    value = _action$payload.value,
                    actionType = _action$payload.actionType,
                    index = _action$payload.index;


                if (actionType === 'addOuter') {
                    var sourceIndex = state.returns.findIndex(function (item) {
                        return item.code === 'Address';
                    });
                    var objectToMove = state.returns[sourceIndex];

                    state = _dotPropImmutable2.default.set(state, componentCode.replace(/\[(\d+)]/g, '.$1') + '.elements', function (elements) {

                        if (sourceIndex !== -1) {
                            return [].concat(_toConsumableArray(elements || []), [{
                                code: 'Action',
                                value: 'Add',
                                elements: [{
                                    elements: objectToMove.elements,
                                    code: 'Object',
                                    value: 'Address'
                                }]
                            }]);
                        } else {
                            return [].concat(_toConsumableArray(elements || []), [{
                                code: 'Action',
                                value: 'Add',
                                elements: null
                            }]);
                        }
                    });

                    if (sourceIndex !== -1) state = _dotPropImmutable2.default.delete(state, 'returns.' + sourceIndex);

                    return state;
                }

                if (actionType === 'addInner') {
                    var rootElement = componentCode.split('.')[0];
                    return _dotPropImmutable2.default.set(state, rootElement.replace(/\[(\d+)]/g, '.$1') + '.elements', function (elements) {
                        var parentGuid = _dotPropImmutable2.default.get(state, '' + componentCode.replace(/\[(\d+)]/g, '.$1')).value;
                        return [].concat(_toConsumableArray(elements || []), [{
                            code: 'Action',
                            value: 'Add',
                            elements: [{
                                elements: [{
                                    code: 'ParentGuid',
                                    value: parentGuid
                                }],
                                code: 'ActionRules'
                            }]
                        }]);
                    });
                }

                if (actionType === 'deleteOuter') {
                    var entitiesIndex = _dotPropImmutable2.default.get(state, '' + componentCode.replace(/\[(\d+)]/g, '.$1')).elements.findIndex(function (el) {
                        return el.code === 'Entities';
                    });

                    state = _dotPropImmutable2.default.set(state, componentCode.replace(/\[(\d+)]/g, '.$1') + '.elements', function (elements) {
                        var entities = elements.find(function (el) {
                            return el.code === 'Entities';
                        });
                        var deleteEntity = entities.elements[index];
                        var deleteEntityGuid = deleteEntity.value;

                        return [].concat(_toConsumableArray(elements || []), [{
                            code: 'Action',
                            value: 'Delete',
                            elements: [{
                                elements: [{
                                    'code': 'Guid',
                                    'value': deleteEntityGuid
                                }],
                                code: 'ActionRules',
                                value: 'Address'
                            }]
                        }]);
                    });

                    state = _dotPropImmutable2.default.delete(state, componentCode.replace(/\[(\d+)]/g, '.$1') + '.elements.' + entitiesIndex + '.elements.' + index);

                    return state;
                }

                if (actionType === 'deleteInner') {
                    var _rootElement = componentCode.split('.')[0];
                    var entities = _dotPropImmutable2.default.get(state, '' + componentCode.replace(/\[(\d+)]/g, '.$1')).elements.find(function (el) {
                        return el.code === 'Entities';
                    });
                    var deleteEntity = entities.elements[index];
                    var deleteEntityGuid = deleteEntity.value;
                    var parentGuid = _dotPropImmutable2.default.get(state, '' + componentCode.replace(/\[(\d+)]/g, '.$1')).value;
                    var _entitiesIndex = _dotPropImmutable2.default.get(state, '' + componentCode.replace(/\[(\d+)]/g, '.$1')).elements.findIndex(function (el) {
                        return el.code === 'Entities';
                    });

                    state = _dotPropImmutable2.default.set(state, _rootElement.replace(/\[(\d+)]/g, '.$1') + '.elements', function (elements) {
                        return [].concat(_toConsumableArray(elements || []), [{
                            code: 'Action',
                            value: 'Delete',
                            elements: [{
                                elements: [{
                                    'code': 'Guid',
                                    'value': deleteEntityGuid
                                }, {
                                    'code': 'ParentGuid',
                                    'value': parentGuid
                                }],
                                code: 'ActionRules'
                            }]
                        }]);
                    });

                    state = _dotPropImmutable2.default.delete(state, componentCode.replace(/\[(\d+)]/g, '.$1') + '.elements.' + _entitiesIndex + '.elements.' + index);

                    return state;
                }

                if (actionType === 'unhide') {
                    return _dotPropImmutable2.default.set(state, componentCode.replace(/\[(\d+)]/g, '.$1') + '.ActuallyIsntHidden', value);
                }

                return _dotPropImmutable2.default.set(state, componentCode.replace(/\[(\d+)]/g, '.$1') + '.elements', function (elements) {
                    var elementIndex = elements.findIndex(function (el) {
                        return el.code === code;
                    });
                    if (elementIndex !== -1) {
                        var newElements = [].concat(_toConsumableArray(elements));
                        newElements[elementIndex].value = value;
                        return newElements;
                    } else if (code !== '' && value !== '') {
                        return [].concat(_toConsumableArray(elements), [{ code: code, value: value }]);
                    } else {
                        return elements;
                    }
                });
            }
        case _workflow.REDUCE_STEP_ANALYTICS:
            {
                return _dotPropImmutable2.default.set(state, 'stepAnalytics', action.payload);
            }
        case _workflow.REDUCE_WORKFLOW_CONFIGURATION:
            {
                return _dotPropImmutable2.default.set(state, 'workflowConfiguration', action.payload);
            }
        default:
            return state;
    }
}

exports.default = workflowReducer;